import React from "react";
import { CheckCircleIcon, ChatDotIcon, PersonQuestionIcon, ExitIcon, InfoIcon, ArrowRightIcon } from "./icons";

const outcomes = [
  { label: "Got answer", count: 892, percent: "71.5%", icon: <CheckCircleIcon />, variant: "green" },
  { label: "Asked follow up", count: 214, percent: "17.1%", icon: <ChatDotIcon />, variant: "indigo" },
  { label: "Requested human", count: 98, percent: "7.8%", icon: <PersonQuestionIcon />, variant: "amber" },
  { label: "Left without response", count: 44, percent: "3.5%", icon: <ExitIcon />, variant: "red" },
];

export default function UserOutcomesCard() {
  return (
    <section className="dash-card">
      <div className="dash-card-header">
        <h2 className="dash-card-title">
          User outcomes
          <span className="an-info-icon" title="How conversations with your assistant typically end.">
            <InfoIcon />
          </span>
        </h2>
      </div>

      <ul className="an-outcomes">
        {outcomes.map((o) => (
          <li key={o.label}>
            <span className={`dash-stat-icon dash-stat-icon--${o.variant} an-outcomes-icon`}>{o.icon}</span>
            <span className="an-outcomes-label">{o.label}</span>
            <span className="an-outcomes-count">{o.count}</span>
            <span className={`an-outcomes-percent an-outcomes-percent--${o.variant}`}>{o.percent}</span>
          </li>
        ))}
      </ul>

      <a href="#outcomes-report" className="dash-card-link an-view-link">
        View outcomes report
        <ArrowRightIcon />
      </a>
    </section>
  );
}
